export enum Preset {
    Last24hour = 'Last24hour',
    Last30days = 'Last30days',
    Last90days = 'Last90days',
    Last365days = 'Last365days',
    Custom = 'Custom',
}
